import { IComponentOptions, IController, IQService } from "angular";
import { StateService } from "angular-ui-router";
import templateUrl from './main-app.component.html';
import './main-app.component.less';
import { NavigationService } from "../core/services";
import { SessionService } from "../core/services/session.service";
import { UtilityService } from "../core/services/utility.service";
import { NavigationModuleViewModel } from "@herbjoy/apex-api-models";

export const MainAppComponent: IComponentOptions = {
    templateUrl,
    transclude: true,
    controller: class MainAppComponent implements IController {
        loaded: boolean;
        authenticated: boolean;
        showSidebar: boolean;
        identity: any;
        hasSession: boolean;
        sessionExpired: boolean;
        navigationModules: NavigationModuleViewModel[];
        constructor(private $q: IQService, private $state: StateService, private employeeService,
            private localeService, private navigationService: NavigationService,
            private sessionService: SessionService, private utilityService: UtilityService,
            private apexIsAuthenticated: boolean,
            private apexIsPreRendered: boolean) {
            'ngInject';

            this.loaded = false;
            // The spinner is loading on init by default;
            this.utilityService.hideLoading();
        }

        $onInit() {
            this.showSidebar = this.apexIsAuthenticated;
            const loading = this.sessionService.isAuthorized()
                .then(authenticated => {
                    this.authenticated = authenticated
                    if (authenticated) {
                        return this.loadAppSessionData()
                    }
                })
                .finally(() => {
                    // Want to hide body and show loader on initial page load,
                    // but not to hide the body every time the spinner is showing.
                    this.loaded = true;
                });

            if (!this.apexIsPreRendered) {
                this.utilityService.showLoadingUntilResolved(loading);
            } else {
                this.loaded = true;
            }
        }

        loadAppSessionData() {
            if (!this.authenticated) {
                return;
            }
            const isImpersonated = this.sessionService.isImpersonated();
            const identity = this.employeeService.retrieveIdentity();
            return this.$q.all([identity, isImpersonated])
                .then(([identity, isImpersonated]) => {
                    identity.isImpersonated = isImpersonated
                    this.identity = identity;
                    return this.identity;
                })
                .then(identity => {
                    this.showSidebar = this.authenticated &&
                        (identity.isImpersonated || !identity.AnyUnAcknowledgedLegalNotices);
                    const countryID = identity ? identity.Country.CountryID : 1;
                    if (countryID) {
                        // Set the default locale based on the user's identity.
                        return this.localeService.retrieveLocales()
                            .then(function (locales) {
                                return locales.filter(function (locale) {
                                    return locale.countryID === countryID;
                                })[0];
                            })
                            .then(defaultLocale => {
                                return this.localeService.setDefaultLocale(defaultLocale.localeID);
                            });
                    } else {
                        return [];
                    }
                })
                .catch(ex => {
                    this.showSidebar = this.authenticated;
                    if (ex.status === 401 && this.authenticated) {
                        // The request to get user data failed to authenticate. Reload
                        // to send the user back to the login page.
                        this.sessionExpired = true;
                        console.log("Reloading to send user back to login page");
                        window.location.reload();
                    } else {
                        this.$state.go("navigationFailed")
                    }
                })
                .then(() => {
                    if (this.showSidebar) {
                        return this.navigationService.retrieveNavigationModules()
                            .then(navigationModules => {
                                this.navigationModules = navigationModules.reduce((modules, navigationModule) => {
                                    // Group modules by name and sort index
                                    let _module = modules.find(p => p.DisplayName === navigationModule.DisplayName
                                        && p.SortIndex === navigationModule.SortIndex);
                                    if (!_module) {
                                        _module = navigationModule;
                                        modules.push(navigationModule);
                                    } else {
                                        _module.SecurityItems.push(...navigationModule.SecurityItems);
                                    }
                                    return modules;
                                }, []);
                                return this.navigationModules;
                            });
                    } else {
                        return [];
                    }
                })
                .catch(() => {
                    this.hasSession = true;
                });
        }
    },
    controllerAs: "vm"
}
